var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header-wrapper',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"page-header-content"})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }